import { IS_DEV } from "../Constants.URL";

/** The HTML template for the Reg Doc Presence and validity dashboard */
export const REG_DOC_P_AND_V_DASHBOARD = "Reg_Doc_Presence" + (IS_DEV ? "_dev" : "");

/** The parameters expected by the Reg Doc Presence and validity dashboard */
export type RegDocPAndVDashboardParams = {
    /** The building id */
    building: string;
    /** The language code */
    lang: string;
}